import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from "../css/gis.module.css"

// export const PopupViewInout = ({ item }) => {
//     const [transitionIn, setTransitionIn] = React.useState(false)

//     React.useEffect(() => {
//         setTransitionIn(false)
//         const key = setTimeout(() => {  
//             setTransitionIn(true)
//         }, 0);

//         return () => clearTimeout(key)
//     }, [item])

//     return (
//         <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
//             <div className='gisPopup' style={{width:'220px'}}>
//                 <div className='popTit'><span className='id'>{item.nm}</span></div>
//                 <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.3fr 0.7fr", gap: "12px", fontSize: "20px"}}>
//                     <div className='subTxt'>유출</div>
//                     <div className='gr subTxt'>{item.outve}</div>
//                     <div className='subTxt'>유입</div>
//                     <div className='subTxt'>{item.inve}</div>
//                 </div>
//             </div>
//         </Zoom>
//     )
// }

export const PopupViewInout = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 0);

        return () => clearTimeout(key)
    }, [item])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${(styles.inoutgisPopup_gis)} gisPopup`} style={{width:'280px'}}>
                <div className='popTit flx a_center'>
                    {/* <span className='flx a_center j_center'>
                        <img src='/images/pin.png' alt='핀'></img>
                    </span> */}
                    <span className='id'>{item.nm}</span>
                </div>
                <div className='popConts flx flx_col' style={{ gap: "16px", fontSize: "20px"}}>                    
                    <div className='flx a_center j_spc_btw' style={{width: '100%'}}>
                        <div className={`${(styles.InSubTxt_gis)} `}>유입</div>
                        <div className= 'flx a_flx_end'><span className={`${(styles.InSubNbr_gis)}`}>{Number(item.inve).toLocaleString('ko-KR')}</span><span className={`${(styles.unit_gis)}`}>대</span></div>
                    </div>
                    <div className='flx a_center j_spc_btw' style={{width: '100%'}}>
                        <div className={`${(styles.OutSubTxt_gis)} `}>유출</div>
                        <div className='flx a_flx_end'><span className={`${(styles.OutSubNbr_gis)}`}>{Number(item.outve).toLocaleString('ko-KR')}</span><span className={`${(styles.unit_gis)}`}>대</span></div>
                    </div>
                </div>
            </div>
        </Zoom>
    )
}